import { useEffect, useState } from 'react';
import useSWR, { mutate } from 'swr';
import getAuthClient from 'Core_Helpers/getAuthClient';
import urlcat from 'urlcat';

const getCardUrl = 'v1/cards/:cardId';
const options = {
  revalidateOnFocus: false,
};

const getCard = async (url) => {
  const authorizedApiClient = await getAuthClient();

  if (authorizedApiClient) {
    return await authorizedApiClient.get(url);
  }
};

const useGetCard = (swrOptions) => {
  const [isPending, setIsPending] = useState(true);
  const [requestData, setRequestData] = useState();
  const [cardResult, setCardResult] = useState();
  const { data: cardResultData, error } = useSWR(
    () => urlcat(process.env.API_BASE_URL, getCardUrl, { cardId: requestData }),
    getCard,
    {
      ...options,
      ...swrOptions,
    },
  );

  useEffect(() => {
    if (cardResultData) {
      setCardResult(cardResultData.data);
    }

    setIsPending(!cardResultData && !error);
  }, [cardResultData, error]);

  const retrieveCard = (cardId) => {
    setRequestData(cardId);
    mutate(cardResultData);
  };

  return { card: cardResult, getCardError: error, isGetCardPending: isPending, retrieveCard };
};

export default useGetCard;
